/**
 * EPC Create Page
 * Page for creating new EPC using multi-step wizard
 *
 * @version 2025.1.0
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  Alert,
} from '@mui/material';
import { PageShell } from '../../components';
import { epcService } from '../../services/epcService';
import { EpcFormData } from '../../types/epc';
import { EPCFormWizard } from './components';

export const EPCCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: EpcFormData) => {
    try {
      setIsSubmitting(true);
      setError(null);
      await epcService.createEpc(data);
      navigate('/epcs');
    } catch (err: unknown) {
      const error = err as { message?: string };
      setError(error.message ?? 'Erro ao criar EPC');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/epcs');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'EPCs', path: '/epcs' },
        { label: 'Novo EPC' },
      ]}
      title="Cadastrar Novo EPC"
      subtitle="Preencha os dados do Equipamento de Proteção Coletiva"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card>
        <CardHeader title="Dados do EPC" />
        <CardContent>
          <EPCFormWizard
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isSubmitting={isSubmitting}
          />
        </CardContent>
      </Card>
    </PageShell>
  );
};

export default EPCCreatePage;
